import { ZendeskChatUnavailablePanelRoot } from './ZendeskChatUnavailablePanel/ZendeskChatUnavailablePanelRoot';
import { useChat } from './useChat';

export const ChatUnavailableRoot: React.VFC<{}> = () => {
    const { isOutOfOfficeOpen, closeOutOfOffice } = useChat();

    return <ZendeskChatUnavailablePanelRoot open={isOutOfOfficeOpen} onClose={closeOutOfOffice} />;
};
